import { Component, OnInit } from '@angular/core';
import { interpolate } from '@angular/core/src/view';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {


  faqGeneral: any =
  [
    {
      "parentName": "What is ADLUUX?",
      "childProperties":
        [ { "propertyName": `ADLUUX is an online platform through which advertisers easily book a public campaign, 
                            target their audience based on time,location and demographics and get precise campaign insights. 
                            Finally, online advertising standards are brought to the physical world! 
                            <br><br>Through ADLUUX, every digital screen in a public space such as a shopping mall, a restaurant or a retail store is turned into an 
                            advertising space and brings additional income to its owners with no effort!` }, ]
    },
    {
      "parentName": "Who can use ADLUUX?",
      "childProperties":
        [ { "propertyName": `The ADLUUX platform can be used both by advertisers and the display owners. 
                            <br><br>If you own a digital display in a public space, by installing our app on your display, you register it into 
                            our network thereby opening up this newly created ad space for the advertise to run their ads on. 
                            Without any effort, the ads are booked and you receive a % of each transaction. 
                            <br><br>If you are an advertiser, through the ADLUUX platform, you upload your content, configure your campaign and run your ad immediately. 
                            As your ad is running, you will be able to track how many people saw it on the ADLUUX Dashboard.` }, ]
    },
    {
      "parentName": "How is ADLUUX different from traditional public advertising?",
      "childProperties":
        [ { "propertyName": `We make it easy - ADLUUX enables advertisers to access and book public ad spaces directly, 
                            without the need for an intermediary. You can upload and edit your campaigns with ease and flexibility, 
                            like with online or social media advertising. 
                            <br><br>We make it affordable - The platform allows advertisers of all budgets and sizes 
                            to promote their brands in public spaces. Whether you are an individual, a local business or a large corporation, you can advertise 
                            starting from 1 hour on any day, time or location of your choice. 
                            <br>We make it targeted and measurable - For the first time ever, 
                            advertisers are able to target audiences in public spaces based on time, location and demographics and receive real-time performance 
                            reports enabled by capturing peoples’ views through digital screens.` }]
    }
  ]

  displayOwnersReg: any =
  [
    {
      "parentName": "What kinds of displays can I register for the ADLUUX network?",
      "childProperties":
        [ { "propertyName": `There is no limit for the type of display that can be registered – 
                            from the smallest tablets to the huge Times Square digital displays. The only prerequisite is that the display is smart and located in a public space. 
                            The displays can also be static or movable – see the difference in the area “For advertisers” under “Upload and configuration”.` }, ]
    },
    {
      "parentName": "How do I register my display for the ADLUUX network?",
      "childProperties":
        [ { "propertyName": `While we are working hard on fully automating this process, you can do this by getting in touch with us on 
                            <a href="mailto:ask@adluux.com ">ask@adluux.com</a> 
                            or by using the <a href="/contact#focus">Contact us</a> form.` }, ]
    },
  ]

  displayOwnersCont: any =
  [
    {
      "parentName": "Can I control what ads get advertised?",
      "childProperties":
        [ { "propertyName": `We have strict internal guidelines to make sure no inappropriate or illegal content is advertised. 
                            After an ad is uploaded, we will review it and approve or reject. Once the ad was approved, you have an additional option to decide whether 
                            to approve or reject it yourself. Be mindful that earnings only come from ads that have had their airtime.` }, ]
    },
  ]

  displayOwnersEarn: any =
  [
    {
      "parentName": "How can I make money from my displays?",
      "childProperties":
        [ { "propertyName": `Once you register your display and provide some additional information about it, 
                            advertisers will be able to see it on the platform and book the ad space. You do not need to do anything in this process, 
                            just relax and collect a big % of each ad booked.` }, ]
    },
    {
      "parentName": "How can I track my earnings?",
      "childProperties":
        [ { "propertyName": `We have developed a special display owner Dashboard for you where you can have an overview of your earnings in addition to other 
                            metrics like the number ads played or the number of views your display is receiving – 
                            the more views the more popular your display will be.` }, ]
    },
  ]
  
  advertisersUpload: any =
  [
    {
      "parentName": "What kind of files can I upload?",
      "childProperties":
        [ { "propertyName": `Currently, you can upload image files (.jpg, .jpeg) and video files (.mp4) with no sound. 
                            The maximum file size is 20MB and a maximum video duration (for optimal results) is 60 seconds.` }, ]
    },
    {
      "parentName": "What ads get the best results?",
      "childProperties":
        [ { "propertyName": `Make sure everything on your ad is clearly legible. Use colors and be creative!` }, ]
    },
    {
      "parentName": "What browsers are supported?",
      "childProperties":
        [ { "propertyName": `Currently, our platform is supported on Microsoft Edge, Chrome, Safari and Mozilla Firefox browsers.` }, ]
    },
    {
      "parentName": "What is the difference between static and movable displays?",
      "childProperties":
        [ { "propertyName": `Movable displays are the ones that are placed in or on top of taxis or other vehicles. 
                            Because they move around, instead of an exact location, you can select a zone where you want your ad to be shown. As soon as the vehicles drives into this zone, 
                            your ad will be displayed. For this reason, we will only charge you the number of minutes your ad will actually be played.
                            <br>Static displays are always in the same place and you can select the exact display and location you want. 
                            Normally, the cost shown at booking will be the exact one you will be charged.` }, ]
    },
    {
      "parentName": "How can I choose when I want to run my ad?",
      "childProperties":
        [ { "propertyName": `Each display (or zone in the case of movable displays) has its own calendar. 
                            You can select any desired date and then the time of day to advertise. 
                            The days do not have to be consecutive and neither the times – the world is your oyster!` }, ]
    },
  ]

  advertisersAdAppRej: any =
  [
    {
      "parentName": "How long do I have to wait until my ad is approved?",
      "childProperties":
        [ { "propertyName": `Our team will always try to approve or reject ads as soon as the order is made. The maximum waiting time is 24 hours.` }, ]
    },
    {
      "parentName": "Why was my ad rejected?",
      "childProperties":
        [ { "propertyName": `There are several reasons why your ad could have been rejected. Please refer to ADLUUX Advertising policy 
                            in <a href="/terms#focus">Terms and conditions</a>.` }, ]
    },
    {
      "parentName": "Is it possible to cancel my ad?",
      "childProperties":
        [ { "propertyName": `Currently, it is not possible to cancel your campaign after your order was placed. 
                            However, we are working hard on implementing this feature and will let you know when it is available.` }, ]
    },
  ]

  advertisersPerformance: any =
  [
    {
      "parentName": "How are my advertising campaign results tracked?",
      "childProperties":
        [ { "propertyName": `You track the results of their ad campaign in real time on our Dashboard. 
                            There you can find information on your spending, remaining budget, number of views and impressions, 
                            total minutes advertised. We are working on implementing other features for even more data and transparency.` }, ]
    },
    {
      "parentName": "What is the difference between a view and an impression?",
      "childProperties":
        [ { "propertyName": `A view is counted when the sensors on the displays detect that someone has looked directly at the ad. 
                            Other sensors count ALL the people that passed by the advertisement and that COULD have seen it, and these are called impressions. 
                            The number of impressions on your Dashboard should therefore always be higher than the number of views.` }, ]
    },
    {
      "parentName": "What is face detection?",
      "childProperties":
        [ { "propertyName": `Each of our displays has sensors for face detection. Face detection means that our software identifies a face (a forehead, two eyes and a nose = face) 
                            when they are looking at the ad and counts them as a view. As opposed to face recognition, face detection does not store any images or videos 
                            nor can recognize if the same person looked at the ad more than once.` }, ]
    },
  ]

  faqCostPayment: any =
  [
    {
      "parentName": "How is the total cost calculated?",
      "childProperties":
        [ { "propertyName": `Total cost at the end of advertisement period is calculated as a total number of minutes advertisement was 
                            displayed multiplied by the price per minute.` }, ]
    },
    {
      "parentName": "What is the “maximum potential cost”?",
      "childProperties":
        [ { "propertyName": `The maximum potential cost is only applicable to movable displays. It equals the total number of minutes in time slots selected by 
                            a user multiplied with prices per minute in selected time slots multiplied with maximum number of displays that can show the advertisement during 
                            the selected time period (this is a mouthful!). In a nutshell, it is a potential cost if the advertisement is displayed 100% of 
                            selected time on all (movable) displays – this can happen when for some reasons all the vehicles come to the same zone (e.g. a fair, a football match etc.). 
                            The maximum potential cost can be reached in cases where all zones have been selected in the same time slot.` }, ]
    },
    {
      "parentName": "What payment methods are accepted?",
      "childProperties":
        [ { "propertyName": `Our platform services can be paid via credit card or (for large companies) invoice payments.` }, ]
    },
    {
      "parentName": "Who is eligible for invoice payments?",
      "childProperties":
        [ { "propertyName": `In order to be able to pay for your advertising via invoice and not via credit card, 
                            each customer has to apply for that type of payment method. Our team will assess each and every 
                            application and approve those that match our criteria. ` }, ]
    },
    {
      "parentName": "Which currencies are used for payments on ADLUUX platform?",
      "childProperties":
        [ { "propertyName": `Currently we only accept payments in Euros.` }, ]
    },
  ]


  ngOnInit() {  
  }
  
  toggleAccordian(data, event, index) {
      var element = event.target;
      element.classList.toggle("active");
      if(data[index].isActive) {
        data[index].isActive = false;
      } else {
        data[index].isActive = true;
      }      
      var panel = element.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/faq/faq.component.ts